import { render, staticRenderFns } from "./DefaultSection.vue?vue&type=template&id=4a6dc180&scoped=true"
import script from "./DefaultSection.vue?vue&type=script&lang=js"
export * from "./DefaultSection.vue?vue&type=script&lang=js"
import style0 from "./DefaultSection.vue?vue&type=style&index=0&id=4a6dc180&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6dc180",
  null
  
)

export default component.exports